import { Skeleton, Stack, Typography } from '@mui/material';
import type { Dispatch, SetStateAction } from 'react';
import { useOwnUserNode } from '/@/hooks/nodes';
import { _ } from '/@/locale';
import { getNodeScopeFilters } from '/@/utils/node-scope';
import FieldsDashboardCard from '../../../components/dashboard-cards/fields-dashboard-card';
import RecommendationsDashboardCard from '../../../components/dashboard-cards/recommendations-dashboard-card';

/**
 * "Tu actividad" for the generic profile. The RV version leads with growers; this
 * profile has none, so it leads with its own fields using the same shared cards.
 */
const ActivitySection = ({
    setOpenCreateRecommendationModal,
}: {
    setOpenCreateRecommendationModal: Dispatch<SetStateAction<boolean>>;
}) => {
    const userNodeQuery = useOwnUserNode();
    const userNodeId = userNodeQuery.data?.id;
    const isContentReady = userNodeId && !userNodeQuery.isValidating;
    const ownFields = getNodeScopeFilters('myFields');

    return (
        <Stack spacing={3} sx={{ flex: 1, width: '100%', minHeight: 0 }}>
            <Stack spacing={1}>
                <Typography color='primary' variant='h5'>
                    {_('Tu actividad')}
                </Typography>
                <Typography color='primary.mui.inactive' variant='body2'>
                    {_('Accedé a la información clave de tus lotes y tus recomendaciones.')}
                </Typography>
            </Stack>
            {isContentReady ? (
                <Stack spacing={2} sx={{ flex: 1, minHeight: 0 }}>
                    <FieldsDashboardCard userNodeId={userNodeId} showNewFieldButton nodeScope={ownFields} />
                    <RecommendationsDashboardCard
                        setOpenCreateRecommendationModal={setOpenCreateRecommendationModal}
                        userNodeId={userNodeId}
                        nodeScope={ownFields}
                    />
                </Stack>
            ) : (
                <Skeleton variant='rectangular' height='500px' width='100%' />
            )}
        </Stack>
    );
};

export default ActivitySection;
